import { Position } from '@turf/helpers';
import { IPoint } from '@/utils/gis/types';

export function positionToPoint(position: Position): IPoint {
  if (position.length < 2) {
    throw new Error('Position must contain at least two elements');
  }
  return [position[0]!, position[1]!];
}
